<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Νέα Συναλλαγή</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <!-- Existing fields -->
            <v-col cols="2">
              <v-text-field
                label="ID"
                v-model="ledgerForm.Id"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    label="Ημερομηνία"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="ledgerForm.Date"
                  @input="menu = false"
                  :max="
                    new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                      .toISOString()
                      .substr(0, 10)
                  "
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                label="Τελική Τιμή"
                type="number"
                v-model="ledgerForm.Value"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="8" sm="6">
              <v-select
                label="Αιτιολογία*"
                v-model="ledgerForm.Action"
                :items="paymItems"
                required
              ></v-select>
            </v-col>
            <v-col cols="8" sm="6">
              <v-select
                v-if="([-5, -6]).includes(ledgerForm.Action)"
                label="Ατιολογία Πληρωμής*"
                v-model="ledgerForm.actionRemarks"
                :items="actionRemarks"
                required
              ></v-select>
            </v-col>
            <v-col cols="4" sm="6">
              <v-select
                v-if="showBank"
                label="Τράπεζα*"
                v-model="bank"
                :items="bankAccs"
                required
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Remarks"
                v-model="ledgerForm.Remarks"
                :hint="remarksText"
                persistent-hint
              >
                <template v-if="showBank" v-slot:append>
                  <v-avatar tile size=46>
                    <img
                      :alt="bank"
                      :src="bankLogo"
                    />
                  </v-avatar>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <small>* Υποχρεωτικά πεδία</small>
      </v-card-text>
      <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        text
        @click="resetPayment"
      >
        Εκκαθάριση
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click.native="close"
      >
        Κλεισιμο
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        :disabled="saveDisable"
        @click="createPayment"
      >
        Αποθηκευση
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

</template>

<script>
 import { clone as _clone } from 'lodash';
import ab from "../assets/ab.png"
import nbg from "../assets/nbg.png"
import pir from "../assets/pir.png"
import eb from "../assets/eb.png"

  export default {

   computed: {
      dateRangeText () {
        return new Date(this.ledgerForm.Date).toISOString().substr(0,10);
      },

      /* remarksText () {
        if (([1,2]).includes(this.ledgerForm.PaymTerm)) {
            return this.ledgerForm.Remarks + " " + this.bank
        } else {
            return this.ledgerForm.Remarks
        }
      },
      */
      remarksText() {
        let remarks = this.ledgerForm.Remarks || '';
        if (this.ledgerForm.actionRemarks) {
          remarks = `${this.ledgerForm.actionRemarks} ${remarks}`
        }
        if (this.ledgerForm.Action === -4) {
          remarks = `ΜΙΣΘΟΔΟΣΙΑ ` + remarks;
        }
        if (this.ledgerForm.Action === -8) {
          remarks = `ΕΝΟΙΚΙΟ ` + remarks;
        }
        return remarks;
      },
      actionRemarks() {
        if (this.ledgerForm.Action === -5) {
          return ["ΦΜΥ", "ΦΠΑ", "ΦΕΕ", "ΙΚΑ", "ΕΦΚΑ"];
        }
        if (this.ledgerForm.Action === -6) {
          return ["ΡΕΥΜΑ", "ΥΕΠΑΜΑ", "ΤΗΛΕΦΩΝΟ"];
        }
        return [];
      },
      showBank () { return true},
      bankLogo () {
        return this.bankLogos[this.bank]
      },
    },
    props: {
        dialog: {
        default: false
      },
        apipath: {
          required: true
      },
     
      ledgerForm: {
        type: Object,
        default() {
          return {
            Id: 0,
            Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            Remarks: '',
            actionRemarks: '',
            Action: -4,
            Value: 0,
         }
        }
      }
    },
    data() {
      return {
        menu: false,
        saveDisable: false,
        bankAccs: [
          {text: "Εθνική", value: 2},
          {text: "Alpha Bank", value: 68},
          {text: "Eurobank", value: 1},
        ], 
        bank: "",
        bankLogos: {
            "@PIR": pir,
             2: nbg,
            68: ab,
            1: eb,
        },
        paymItems: [
          {text: "Μισθοδοσία", value: -4},
          {text: "Πληρωμή οφειλών", value: -5},
          {text: "Πληρωμή παγίων", value: -6},
          {text: "Ενοίκιο", value: -8},
          {text: "Μεταφορά (Πίστωση)", value: 1},
          {text: "Κατάθεση", value: 0},
          {text: "Μεταφορά (Χρέωση)", value: -1},
          {text: "Ανάληψη", value: -2},
          {text: "Προμήθεια POS", value: -9},
        ],
        newledgerForm: {
          Id: null,
          Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          Remarks: null,
          Action: 1,
          Value: 0,
       },
     }
    },

    methods: {
        close() {
        this.$emit('update:dialog', false)
      },
      async createPayment() {
        let payment = this.ledgerForm;
        /* if (this.showBank) {
            if (this.ledgerForm.Remarks){ 
              this.ledgerForm.Remarks += " " + this.bank
            } else {
              this.ledgerForm.Remarks = this.bank
            }
          }
        */
        payment.BankId = this.bank;
        payment.Remarks = this.remarksText;
        var response = await this.$api.post(`${this.apipath}`, payment);
        if (response.status == 201) {
          this.ledgerForm.Id = response.data.Id;
          this.saveDisable = true;
          alert(`Καταχωρήθηκε συναλλαγή αξίας ${this.ledgerForm.Value} € με αριθμό ${this.ledgerForm.Id}.`);
        } else {
          alert(response.data);
        }
      },
      resetPayment() {
        this.ledgerForm = _clone(this.newledgerForm);
        this.saveDisable = false;
      },
    },
  }

</script>
